import { createSelector } from 'reselect';
import { getOffsetDaysOfWeek } from 'helpers/intl-fns';

const selectLocaleDataRoot = state => {
  return state.localeData || {};
};

export const selectLocaleData = createSelector(selectLocaleDataRoot, localeData => {
  const { locale, startWeekOn } = localeData;
  const en = getOffsetDaysOfWeek(startWeekOn).map(({ value }) => value);
  const long = getOffsetDaysOfWeek(startWeekOn, locale, 'long').map(({ value }) => value);
  const short = getOffsetDaysOfWeek(startWeekOn, locale, 'short').map(({ value }) => value);
  const narrow = getOffsetDaysOfWeek(startWeekOn, locale, 'narrow').map(({ value }) => value);

  return {
    ...localeData,
    offsetDaysOfWeek: en.map((englishReference, i) => ({
      en: englishReference,
      long: long[i],
      short: short[i],
      narrow: narrow[i],
    })),
  };
});

export const selectStartWeekOn = createSelector(selectLocaleDataRoot, localeData => localeData.startWeekOn);

// selectLocale :: State -> String
export const selectLocale = createSelector(selectLocaleData, localeData => localeData.locale);
